import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMobile = () => {
  return (
    <g>
      <path d="m11.4248.0893h-6.85a1.7021 1.7021 0 0 0 -1.7 1.7v12.4207a1.7021 1.7021 0 0 0 1.7 1.7h6.85a1.7021 1.7021 0 0 0 1.7-1.7v-12.42a1.7021 1.7021 0 0 0 -1.7-1.7007zm-6.85 1.4h6.85a.3.3 0 0 1 .3.3v.9189h-7.4494v-.9182a.3.3 0 0 1 .2998-.3zm7.1494 2.6191v6.6826h-7.4488v-6.6821zm-.3 10.4014h-6.85a.3.3 0 0 1 -.3-.3v-2.0179h7.4492v2.0181a.3005.3005 0 0 1 -.2986.3z" />
      <path d="m8.8906 12.647h-1.7806a.7.7 0 1 0 0 1.4h1.78a.7.7 0 1 0 0-1.4z" />
    </g>
  );
};

export default withIcon(IconMobile);
